module.exports = __webpack_public_path__ + "packs/media/images/Spot_Active-f55863807d341248cb46d738467ab4b3.svg";